import React from 'react';
import { Accordion, Col, Container, Row } from 'react-bootstrap';

const UseCaseAccordion = ({ content }) => {
  return (
    <Container className="mt-5" fluid style={{ background: '#e8f3ff' }}>
      <Container className="p-md-5">
        <Row>
          <Col
            md="3"
            className="d-flex justify-content-center align-items-center">
            <h5 className="text-lg px-2">
              <span className="text-blue">GAINSS in Action –</span>{' '}
              <span className="text-light-blue">
                Solving Real-World Challenges
              </span>
            </h5>
          </Col>
          <Col className="mt-4 mt-md-0 mb-4 mb-md-0">
            <Accordion defaultActiveKey={0}>
              {content.map((item, index) => (
                <Accordion.Item key={index} eventKey={index} className="mt-3">
                  <Accordion.Header>
                    <span className="text-grey">{item.title}</span>
                  </Accordion.Header>
                  <Accordion.Body className="px-4">
                    {item.challenge && (
                      <p className="text-606060">
                        <strong>Challenge:</strong> {item.challenge}
                      </p>
                    )}
                    {item.solution && (
                      <div className="text-606060">
                        <strong>How GAINSS Helps:</strong>
                        {Array.isArray(item.solution) ? (
                          <ul className="mt-2">
                            {item.solution.map((point, i) => (
                              <li key={i}>{point}</li>
                            ))}
                          </ul>
                        ) : (
                          <p>{item.solution}</p>
                        )}
                      </div>
                    )}
                    {item.outcome && (
                      <p className="text-606060">
                        <strong>Outcome:</strong> {item.outcome}
                      </p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default UseCaseAccordion;
